import { Component, OnInit } from "@angular/core";

import { AuthenticationService } from "../common/authentication/authentication.service";
import { RegistrationService } from "./registration-service/registration.service";

@Component({
	selector: "sdp-registration",
	templateUrl: "./registration.component.html"
})
export class RegistrationComponent implements OnInit {

	public progressVisible = false;
	public isIdle = false;

	constructor(
		private auth: AuthenticationService,
		private registrationService: RegistrationService,
	) {
	}

	public ngOnInit() {
		this.registrationService.loaderVisible.subscribe((visible) => {
			this.progressVisible = visible;
		});

		/* Problem is that getCurrentNavigation returns Navigation only during the navigation *
		 * and returns null after the navigation ended. So the Navigation is no longer available *
		 * in the onInit lifecycle hook. We need to read the data from browser’s history object */
		if (!!history.state && !!history.state.idle) {
			this.isIdle = history.state.idle;
		}
	}

	public logout() {
		this.auth.logout();
	}
}
